import i18n from '@/i18n';
import { onHandleFakeId } from '@/utils/handlers';

const surnameAddressPhoneNumber = '名前（姓）・住所・電話番号';

const initDefaultFreeBlock = () => {
    return { is_active: true, title: '', data: '' };
};

const LIST_TAB = (data = null) => {
    const defaultTabs = [
        {
            id: 1,
            make_id: 1,
            name: '【管理画面情報】',
            is_active: true,
            is_permanent: true,
            key: 'information_management'
        },
        {
            id: 2,
            make_id: 2,
            name: '【通数依頼】はがき',
            is_active: true,
            is_permanent: true,
            key: 'request_parameter_postcard'
        },
        {
            id: 3,
            make_id: 3,
            name: '【通数依頼】WEB',
            is_active: true,
            is_permanent: true,
            key: 'request_parameter_web'
        },
        {
            id: 4,
            make_id: 4,
            name: '【通数依頼】X・Instagram＃',
            is_active: true,
            is_permanent: true,
            key: 'request_parameter_twitter_instagram'
        },
        {
            id: 5,
            make_id: 5,
            name: '【通数依頼】Xリポスト',
            is_active: true,
            is_permanent: true,
            key: 'request_parameter_twitter_rt'
        },
        {
            id: 6,
            make_id: 6,
            name: '【通数依頼】LINE（Lタゲ）',
            is_active: true,
            is_permanent: true,
            key: 'request_parameter_line'
        },
        {
            id: 7,
            make_id: 7,
            name: '【抽選】オープンCP',
            is_active: true,
            is_permanent: true,
            key: 'lottery_campaign_open'
        },
        {
            id: 8,
            make_id: 8,
            name: '【抽選】クローズCP',
            is_active: true,
            is_permanent: true,
            key: 'lottery_campaign_close'
        },
        {
            id: 9,
            make_id: 9,
            name: '【抽選】X',
            is_active: true,
            is_permanent: true,
            key: 'lottery_twitter'
        },
        {
            id: 10,
            make_id: 10,
            name: '【抽選】Instagram',
            is_active: true,
            is_permanent: true,
            key: 'lottery_instagram'
        },
        {
            id: 11,
            make_id: 11,
            name: '【抽選】LINE（Lタゲ）',
            is_active: true,
            is_permanent: true,
            key: 'lottery_line'
        }
    ];

    if (data?.partner_request_free_sheet?.length > 0) {
        data?.partner_request_free_sheet.forEach((item) => {
            defaultTabs.push({
                id_record: item.id,
                make_id: onHandleFakeId(defaultTabs),
                name: item.sheet,
                information_tab: {
                    title_field: item.title,
                    ...initTabContentDynamic({ content_tab: item.data })
                },
                is_active: item.is_active,
                is_permanent: false,
                key: 'new_tab_create'
            });
        });
    }

    return defaultTabs.map((tab) => {
        const dataConfig = data[tab.key];
        const isActiveFromData = dataConfig?.is_active;
        return {
            ...tab,
            is_active: isActiveFromData ?? tab.is_active
        };
    });
};

const DATA_REQUIRE = () => {
    return {
        campaign_id: null,
        information_management: {
            is_active: true,
            storage_site: {
                data: '',
                is_active: true
            },
            file_name: {
                data: '',
                is_active: true
            },
            web_management_screen: {
                data: '',
                is_active: true,
                analytic_form_url_out: [{ data: '' }]
            },
            social_media_account: {
                data: '',
                is_active: true
            },
            cr_supporter: {
                data: '',
                is_active: true
            },
            free_block_storage_location: initDefaultFreeBlock(),
            free_block_web_management: initDefaultFreeBlock(),
            free_block_social_media: initDefaultFreeBlock(),
            free_block_cr_supporter: initDefaultFreeBlock()
        },
        request_parameter_web: {
            is_active: true,
            registration_form: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            application_form_id_asia_only: {
                data: '（例）0000　※エイジアのフォーム一覧のIDを記載してください。',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            form_name: {
                data: '（例）●●●●●●キャンペーン応募フォーム',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_1: {
                data: 'メールドメイン(＠●●)を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_2: {
                data: '※「テスト・test」「＠paldia.co.jp」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_line: {
            is_active: true,
            registration_form: {
                data: '＜応募ツールのショートコード＞\n※Lターゲット以外の場合、該当のツールの詳細情報を記載',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_name_in_cr: {
                data: '（例）0000　※Lターゲット内に登録されているキャンペーンIDと設定名を記載してください。',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            date_end_time_field: {
                data: '情報更新日時／応募最終日時',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application: {
                data: '「テスト」「test」「パルディア」「paldia」「＠paldia.co.jp」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_postcard: {
            is_active: true,
            address: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            sorting_method: {
                data: '手仕分け',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_expiration_date: {
                data: '※消印有効期限：●月●日消印有効',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_twitter_rt: {
            is_active: true,
            overview_campaign: [],
            sns: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            collection_tools: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_name_atelu_only: {
                data: '（例）●●キャンペーン　※ATELUのキャンペーン一覧タイトルを記載',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_twitter_rt: {
                data: '引用リポストは応募対象に 含む／含まない ',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_to_be_collected_word: {
                data: 'リポスト⇒（対象文言）以外除外',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_to_be_collected_url: {
                data: '引用リポスト⇒（対象URL）以外除外',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_1: {
                data: 'キャンペーン実施公式アカウント（＠●●）を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_2: {
                data: 'アカウント(＠●●)を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_3: {
                data: '※「＠nohinpaldia」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_detail_direction: {
                data: '投稿文のRT数と応募報告数に差異がないか確認！',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_twitter_instagram: {
            is_active: true,
            overview_campaign: [],
            sns: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            collection_tools: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_name_atelu_only: {
                data: '（例）●●キャンペーン　※ATELUのキャンペーン一覧タイトルを記載',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            tag_collected: {
                data: '＃●●（AND／OR）＃●●',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_1: {
                data: 'キャンペーン実施公式アカウント（＠●●）を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_2: {
                data: 'アカウント(＠●●)を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_3: {
                data: '※「テスト・test」「＠paldia.co.jp」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        lottery_campaign_open: {
            is_active: true,
            prizes: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_lottery: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_postcard: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            winning_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            winning_condition_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            prize_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_distribution_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_3: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_quiz_answer_details: {
                data: 'クイズの答え「」',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_survey_conditions_etc: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            unique_id_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            unique_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '空欄',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_deficiency_check: initDefaultFreeBlock()
        },
        lottery_campaign_close: {
            is_active: true,
            prizes: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_lottery: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_postcard: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            unique_id_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            unique_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            prize_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_distribution_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_3: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_quiz_answer_details: {
                data: 'クイズの答え「」',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_survey_conditions_etc: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '空欄',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_date: {
                data: {
                    start_date: '',
                    end_date: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            shipping: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_price: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_store_or_distribution: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_info_other: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_deficiency_check: initDefaultFreeBlock()
        },
        lottery_instagram: {
            is_active: true,
            hashtags: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            excluded_accounts: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            official_account_follow_check_1: {
                data: 'あり（目視チェック）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            official_account_follow_check_2: {
                data: 'DM配信時の対応でOK',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_followers: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_follower_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_posts: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_post_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_likes: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_like_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            required_words_in_the_post: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_word_count: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlapping_conditions_account_id: {
                data: '完全一致',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_items_to_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            account_name: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_keywords: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            profile_statement: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            presence_of_specified_keyword: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_condition_prize_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file_status_check: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_extracted: {
                data: {
                    start_date: '',
                    end_date: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions_status_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_items: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching_data: {
                data: {
                    text_1: '＜あり(フォーム照合機能なしの場合＞',
                    text_2: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_preson_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_others: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_image_censorship: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_duplicate_prize_check: initDefaultFreeBlock(),
            free_block_duplicate_collation_check: initDefaultFreeBlock(),
            free_block_condition_check: initDefaultFreeBlock()
        },
        lottery_twitter: {
            is_active: true,
            hashtags: {
                data: [],
                sum_total_winner: 0
            },
            twitter_rt: {
                data: [
                    {
                        name: 'hashtag1',
                        preliminary_winner: 0,
                        number_of_win: 0,
                        total_winner: 0,
                        is_active: true,
                        first_check: {
                            id: '',
                            name: '',
                            change: true
                        },
                        secondary_check: {
                            id: '',
                            name: '',
                            change: true
                        }
                    },
                    {
                        name: 'hashtag1',
                        preliminary_winner: 0,
                        number_of_win: 0,
                        total_winner: 0,
                        is_active: true,
                        first_check: {
                            id: '',
                            name: '',
                            change: true
                        },
                        secondary_check: {
                            id: '',
                            name: '',
                            change: true
                        }
                    }
                ],
                //sum of total_winner = 22 + 23
                sum_total_winner: 0
            },
            lottery_method: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            excluded_accounts: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            official_account_follow_check: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_followers: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_follower_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_posts: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_post_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            required_words_in_the_post: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_word_count: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlapping_conditions_account_id: {
                data: '完全一致',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_items_to_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            account_name: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_keywords: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            profile_statement: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            presence_of_specified_keyword: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_condition_prize_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file_status_check: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_extracted: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions_status_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_items: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching_data: {
                data: {
                    text_1: '＜あり(フォーム照合機能なしの場合＞',
                    text_2: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_preson_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_others: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_image_censorship: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_duplicate_prize_check: initDefaultFreeBlock(),
            free_block_duplicate_collation_check: initDefaultFreeBlock(),
            free_block_condition_check: initDefaultFreeBlock()
        },
        lottery_line: {
            is_active: true,
            prizes: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            lottery_method_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_id_record: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_title: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            application_validity_period: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            prize_winning: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_application_form: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_distribution: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_condition_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_type: [],
            same_household_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_type: [],
            same_person_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate: [],
            others_duplicate_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_error_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_validity_period: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            shipping: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_store_or_distribution: {
                data: {
                    select_data: [],
                    input_data: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_info_other: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_info_other_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_deficiency_check: initDefaultFreeBlock()
        }
    };
};
const DATA_REQUIRE_11 = () => {
    return {
        campaign_id: null,
        information_management: {
            is_active: true,
            storage_site: {
                data: '',
                is_active: true
            },
            file_name: {
                data: '',
                is_active: true
            },
            web_management_screen: {
                data: '',
                is_active: true,
                analytic_form_url_out: [{ data: '' }]
            },
            social_media_account: {
                data: '',
                is_active: true
            },
            cr_supporter: {
                data: '',
                is_active: true
            },
            free_block_storage_location: initDefaultFreeBlock(),
            free_block_web_management: initDefaultFreeBlock(),
            free_block_social_media: initDefaultFreeBlock(),
            free_block_cr_supporter: initDefaultFreeBlock()
        },
        request_parameter_web: {
            is_active: true,
            registration_form: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            application_form_id_asia_only: {
                data: '（例）0000　※エイジアのフォーム一覧のIDを記載してください。',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            form_name: {
                data: '（例）●●●●●●キャンペーン応募フォーム',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_1: {
                data: 'メールドメイン(＠●●)を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_2: {
                data: '※「テスト・test」「＠paldia.co.jp」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_line: {
            is_active: true,
            registration_form: {
                data: '＜応募ツールのショートコード＞\n※Lターゲット以外の場合、該当のツールの詳細情報を記載',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_name_in_cr: {
                data: '（例）0000　※Lターゲット内に登録されているキャンペーンIDと設定名を記載してください。',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            date_end_time_field: {
                data: '情報更新日時／応募最終日時',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application: {
                data: '「テスト」「test」「パルディア」「paldia」「＠paldia.co.jp」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_postcard: {
            is_active: true,
            address: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            sorting_method: {
                data: '手仕分け',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_expiration_date: {
                data: '※消印有効期限：●月●日消印有効',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_twitter_rt: {
            is_active: true,
            overview_campaign: [],
            sns: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            collection_tools: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_name_atelu_only: {
                data: '（例）●●キャンペーン　※ATELUのキャンペーン一覧タイトルを記載',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },

            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_twitter_rt: {
                data: '引用リポストは応募対象に 含む／含まない ',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_to_be_collected_word: {
                data: 'リポスト⇒（対象文言）以外除外',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_to_be_collected_url: {
                data: '引用リポスト⇒（対象URL）以外除外',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_1: {
                data: 'キャンペーン実施公式アカウント（＠●●）を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_2: {
                data: 'アカウント(＠●●)を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_3: {
                data: '※「＠nohinpaldia」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_detail_direction: {
                data: '投稿文のRT数と応募報告数に差異がないか確認！',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        request_parameter_twitter_instagram: {
            is_active: true,
            overview_campaign: [],
            sns: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            collection_tools: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_name_atelu_only: {
                data: '（例）●●キャンペーン　※ATELUのキャンペーン一覧タイトルを記載',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            tag_collected: {
                data: '＃●●（AND／OR）＃●●',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            reporting_schedule_detail: {
                data: '※詳細はスケジュールをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            contents_of_report_detail: {
                data: '※詳細は通数フォーマットをご確認ください',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_1: {
                data: 'キャンペーン実施公式アカウント（＠●●）を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_2: {
                data: 'アカウント(＠●●)を除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            test_application_3: {
                data: '※「テスト・test」「＠paldia.co.jp」は除く',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            invalid_content: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_information: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_campaign_overview: initDefaultFreeBlock(),
            free_block_report_number: initDefaultFreeBlock(),
            free_block_other: initDefaultFreeBlock()
        },
        lottery_campaign_open: {
            is_active: true,
            prizes: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_lottery: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_postcard: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            winning_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            winning_condition_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            unique_id_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            unique_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            prize_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_distribution_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_3: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_quiz_answer_details: {
                data: 'クイズの答え「」',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_survey_conditions_etc: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '空欄',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_deficiency_check: initDefaultFreeBlock()
        },
        lottery_campaign_close: {
            is_active: true,
            unique_id_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            unique_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            prizes: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_lottery: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_postcard: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            prize_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_distribution_overlap: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_3: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_quiz_answer_details: {
                data: 'クイズの答え「」',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_survey_conditions_etc: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_with_other_data_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '空欄',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_date: {
                data: {
                    start_date: '',
                    end_date: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            shipping: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_price: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_store_or_distribution: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_info_other: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_deficiency_check: initDefaultFreeBlock()
        },
        lottery_instagram: {
            is_active: true,
            hashtags: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            excluded_accounts: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            official_account_follow_check_1: {
                data: 'あり（目視チェック）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            official_account_follow_check_2: {
                data: 'DM配信時の対応でOK',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_followers: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_follower_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_posts: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_post_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_likes: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_like_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            required_words_in_the_post: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_word_count: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlapping_conditions_account_id: {
                data: '完全一致',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_items_to_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            account_name: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_keywords: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            profile_statement: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            presence_of_specified_keyword: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_condition_prize_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file_status_check: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_extracted: {
                data: {
                    start_date: '',
                    end_date: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions_status_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_items: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching_data: {
                data: {
                    text_1: '＜あり(フォーム照合機能なしの場合＞',
                    text_2: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_preson_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_others: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_image_censorship: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_duplicate_prize_check: initDefaultFreeBlock(),
            free_block_duplicate_collation_check: initDefaultFreeBlock(),
            free_block_condition_check: initDefaultFreeBlock()
        },
        lottery_twitter: {
            is_active: true,
            hashtags: {
                data: [],
                sum_total_winner: 0
            },
            twitter_rt: {
                data: [
                    {
                        name: 'hashtag1',
                        preliminary_winner: 0,
                        number_of_win: 0,
                        total_winner: 0,
                        is_active: true,
                        first_check: {
                            id: '',
                            name: '',
                            change: true
                        },
                        secondary_check: {
                            id: '',
                            name: '',
                            change: true
                        }
                    },
                    {
                        name: 'hashtag1',
                        preliminary_winner: 0,
                        number_of_win: 0,
                        total_winner: 0,
                        is_active: true,
                        first_check: {
                            id: '',
                            name: '',
                            change: true
                        },
                        secondary_check: {
                            id: '',
                            name: '',
                            change: true
                        }
                    }
                ],
                //sum of total_winner = 22 + 23
                sum_total_winner: 0
            },
            lottery_method: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            excluded_accounts: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            official_account_follow_check: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_followers: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_follower_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_posts: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_post_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            required_words_in_the_post: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            post_word_count: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_condition_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            number_of_confirmed_cases_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlapping_conditions_account_id: {
                data: '完全一致',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_items_to_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            account_name: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specified_keywords: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            profile_statement: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            presence_of_specified_keyword: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_2: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            check_the_latest_posts_3: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_condition_prize_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            target_file_status_check: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            period_conditions_extracted: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            specifies_the_data_format_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions_status_check: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            matching_items: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            condition_maching_data: {
                data: {
                    text_1: '＜あり(フォーム照合機能なしの場合＞',
                    text_2: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_id_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_house_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_person_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_same_preson_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            overlap_condition_others: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '番地有無',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '桁数不足',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: 'メールアドレスの形をしているか（@があり、半角英数）',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_image_censorship: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_duplicate_prize_check: initDefaultFreeBlock(),
            free_block_duplicate_collation_check: initDefaultFreeBlock(),
            free_block_condition_check: initDefaultFreeBlock()
        },
        lottery_line: {
            is_active: true,
            prizes: {
                data: [],
                sum_total_winner: 0
            },
            lottery_method: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            lottery_method_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_id_record: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            campaign_title: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            application_validity_period: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            prize_winning: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_application_form: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            cross_distribution: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            ratio_specification_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_conditions: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_condition_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_type: [],
            same_household_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_household_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_type: [],
            same_person_1: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            same_person_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate: [],
            others_duplicate_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            others_duplicate_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_error_name: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_1: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            address_verification_2: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_phone_number_is_incomplete: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            confirm_email_address_is_incomplete: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_errors: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            other_error_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_validity_period: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            shipping: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_conditions: {
                data: '',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_store_or_distribution: {
                data: {
                    select_data: [],
                    input_data: ''
                },
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_info_other: {
                data: [],
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            purchase_info_other_detail: {
                data: '＜ありの場合詳細記入＞',
                is_active: true,
                first_check: {
                    id: '',
                    name: '',
                    change: true
                },
                secondary_check: {
                    id: '',
                    name: '',
                    change: true
                }
            },
            free_block_other: initDefaultFreeBlock(),
            free_block_lottery_condition: initDefaultFreeBlock(),
            free_block_duplicate_check: initDefaultFreeBlock(),
            free_block_deficiency_check: initDefaultFreeBlock()
        }
    };
};

const configHelper = {
    configSelectCampaign: {
        trackBy: 'id',
        label: 'name',
        error: false,
        errorField: '',
        errorMsg: '',
        isRemove: true
    },
    configModalCommon: {
        title: 'タブを追加',
        model: false,
        scrollable: true,
        hideFooter: false,
        size: 'md',
        centered: true,
        validate: true
    },
    configModalPreviewPartner: {
        title: 'プレビュー',
        model: false,
        scrollable: true,
        hideFooter: false,
        indexEditor: 0,
        size: '4xl'
    }
};

const initAddTab = (data = null) => {
    return {
        name_tab: data?.name_tab || '',
        title_field: data?.title_field || ''
    };
};
const configAddTab = () => {
    return {
        name_tab: {
            error: false,
            errorField: i18n.t('screenRequired.nameTab'),
            typesValidate: ['required', 'max255']
        },
        title_field: {
            error: false,
            errorField: i18n.t('screenRequired.titleTab'),
            typesValidate: ['required', 'max255']
        }
    };
};

const initTabContentDynamic = (data = null) => {
    return {
        content_tab: data?.content_tab || ''
    };
};

const configTabContentDynamic = (data = null) => {
    return {
        content_tab: {
            error: false,
            errorField: data?.title_field || 'Tiêu đề trường',
            errorCustomMess: '',
            typesValidate: []
        }
    };
};

export {
    configHelper,
    surnameAddressPhoneNumber,
    DATA_REQUIRE,
    DATA_REQUIRE_11,
    LIST_TAB,
    initAddTab,
    configAddTab,
    initTabContentDynamic,
    configTabContentDynamic,
    initDefaultFreeBlock
};
